import type * as Types from '../../../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetSuspendedRecommendationsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetSuspendedRecommendationsQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly currentCompany?: { readonly __typename?: 'AccountsCompany', readonly recommendationSuspendeds: ReadonlyArray<{ readonly __typename?: 'YalperRecommendationSuspended', readonly id: string, readonly sensorName: string, readonly suspendedUntil: string }> } | null } | null };

export type GetRecommendationsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetRecommendationsQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly currentCompany?: { readonly __typename?: 'AccountsCompany', readonly lastRecommendations: ReadonlyArray<{ readonly __typename?: 'YalperRecommendation', readonly checks: number, readonly found: number, readonly id: string, readonly new: number, readonly sensor: { readonly __typename?: 'YalperSensor', readonly name: string, readonly isPaused: boolean } }> } | null } | null };


export const GetSuspendedRecommendationsDocument = gql`
    query GetSuspendedRecommendations {
  currentUser {
    currentCompany {
      recommendationSuspendeds {
        id
        sensorName
        suspendedUntil
      }
    }
  }
}
    `;

/**
 * __useGetSuspendedRecommendationsQuery__
 *
 * To run a query within a React component, call `useGetSuspendedRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuspendedRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuspendedRecommendationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSuspendedRecommendationsQuery(baseOptions?: Apollo.QueryHookOptions<GetSuspendedRecommendationsQueryPage, GetSuspendedRecommendationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuspendedRecommendationsQueryPage, GetSuspendedRecommendationsQueryVariables>(GetSuspendedRecommendationsDocument, options);
      }
export function useGetSuspendedRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuspendedRecommendationsQueryPage, GetSuspendedRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuspendedRecommendationsQueryPage, GetSuspendedRecommendationsQueryVariables>(GetSuspendedRecommendationsDocument, options);
        }
export function useGetSuspendedRecommendationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSuspendedRecommendationsQueryPage, GetSuspendedRecommendationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSuspendedRecommendationsQueryPage, GetSuspendedRecommendationsQueryVariables>(GetSuspendedRecommendationsDocument, options);
        }
export type GetSuspendedRecommendationsQueryHookResult = ReturnType<typeof useGetSuspendedRecommendationsQuery>;
export type GetSuspendedRecommendationsLazyQueryHookResult = ReturnType<typeof useGetSuspendedRecommendationsLazyQuery>;
export type GetSuspendedRecommendationsSuspenseQueryHookResult = ReturnType<typeof useGetSuspendedRecommendationsSuspenseQuery>;
export type GetSuspendedRecommendationsQueryResult = Apollo.QueryResult<GetSuspendedRecommendationsQueryPage, GetSuspendedRecommendationsQueryVariables>;
export const GetRecommendationsDocument = gql`
    query GetRecommendations {
  currentUser {
    currentCompany {
      lastRecommendations {
        checks
        found
        id
        sensor {
          name
          isPaused
        }
        new
      }
    }
  }
}
    `;

/**
 * __useGetRecommendationsQuery__
 *
 * To run a query within a React component, call `useGetRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRecommendationsQuery(baseOptions?: Apollo.QueryHookOptions<GetRecommendationsQueryPage, GetRecommendationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecommendationsQueryPage, GetRecommendationsQueryVariables>(GetRecommendationsDocument, options);
      }
export function useGetRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecommendationsQueryPage, GetRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecommendationsQueryPage, GetRecommendationsQueryVariables>(GetRecommendationsDocument, options);
        }
export function useGetRecommendationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecommendationsQueryPage, GetRecommendationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecommendationsQueryPage, GetRecommendationsQueryVariables>(GetRecommendationsDocument, options);
        }
export type GetRecommendationsQueryHookResult = ReturnType<typeof useGetRecommendationsQuery>;
export type GetRecommendationsLazyQueryHookResult = ReturnType<typeof useGetRecommendationsLazyQuery>;
export type GetRecommendationsSuspenseQueryHookResult = ReturnType<typeof useGetRecommendationsSuspenseQuery>;
export type GetRecommendationsQueryResult = Apollo.QueryResult<GetRecommendationsQueryPage, GetRecommendationsQueryVariables>;